import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="36968" id="why-choose-watchlaunch" className="bg-muted py-[120px] relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div ref={ref} className={cn("flex flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-foreground text-[32px] md:text-[40px] font-sans font-bold tracking-tight mb-8">
            Why Start with 50 Pieces?
          </h2>
          
          <ul className="space-y-4 text-left inline-block">
            <li className="flex items-center gap-3 text-foreground text-lg font-sans !text-center md:text-xl">Most watch suppliers require 500–1,000 pieces minimum. We start at 50 — so you can test your concept, sell through, and scale confidently without risking your budget on unproven designs.</li>
            
            
          </ul>
        </div>
      </div>
    </section>;
}